import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import POSMain from "../pages/POSMain";
// import axios from "axios";
// import { apiKey } from "../config/config";

export default function POSLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("rms-admin"));

    if (!user) {
      navigate("/admin");
    } 
  }, [navigate]);
  return (
    <>
      <Routes>
        <Route path="/main" element={<POSMain />} />
      </Routes>
    </>
  );
}
